/**
 * GridStack visual reading order: smaller row (`y`) first, then column (`x`), then `id` (e.g. widget
 * id or `gs-id`), then an optional tie-break (e.g. DOM index for items without a grid id / same cell).
 *
 * Matches `compareWidgetsGridReadingOrder` / `sortWidgetsGridReadingOrder` for data objects and the
 * `gs-y` / `gs-x` / `gs-id` extraction path for DOM roots.
 */
type GridReadingOrderComparable = {
  y: number;
  x: number;
  id: string;
  /** Used when `y`, `x`, and `id` fully tie (e.g. stable document order). */
  tie?: number;
};

export const compareGridReadingOrder = (
  a: GridReadingOrderComparable,
  b: GridReadingOrderComparable
): number => {
  if (a.y !== b.y) return a.y - b.y;
  if (a.x !== b.x) return a.x - b.x;
  if (a.id !== b.id) return a.id.localeCompare(b.id);
  return (a.tie ?? 0) - (b.tie ?? 0);
};
